import {ValidationFunction} from "../validation-function";
import {ValidationResultItem} from "../validation-result-item";

const slugPattern = /^[-_0-9a-z]*$/;

// TODO: Move to "../rules/slug-validator.ts"
// TODO: 適切に分割する？
export const validateSlug: ValidationFunction = () => {
    return (s) => {
        if (!slugPattern.test(s)) {
            return [
                new ValidationResultItem(
                    "slug.pattern",
                    `半角小文字英字、半角数字、ハイフン（-）、アンダースコア（_）のみ入力してください。`,
                ),
            ];
        }
        return [];
    };
};

// MEMO:
// サービスDB向けにスラッグバリデーションを文字列超過と文字種チェックを統合。
// しかし将来的に分割する場合、不要となる関数となりえます。
export const validateLengthWithSlug: ValidationFunction = (min?: number, max?: number) => {
    return (s) => {
        const items = [];
        const length = s.length;

        if (min !== undefined && length < min) {
            items.push(
                new ValidationResultItem(
                    "length.min",
                    `${min}字以上で半角小文字英字、半角数字、ハイフン（-）、アンダースコア（_）のみ入力してください。`,
                ),
            );
        }

        if (max !== undefined && length > max) {
            items.push(
                new ValidationResultItem(
                    "length.max",
                    `${max}字以内で半角小文字英字、半角数字、ハイフン（-）、アンダースコア（_）のみ入力してください。`,
                ),
            );
        }

        if (!slugPattern.test(s)) {
            items.push(
                new ValidationResultItem(
                    "slug.pattern",
                    `${max}字以内で半角小文字英字、半角数字、ハイフン（-）、アンダースコア（_）のみ入力してください。`,
                ),
            );
        }

        return items;
    };
};
